<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aSRMKb/tc-custom/9781597098427.jpg?1705766095515" alt="This image is the cover for the book Old Guy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Guy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“When has geezerhood been handled so appealingly? . . . A true American hero is born.” —Albert Goldbarth, National Book Critics Circle Award–winning author of <i>Saving Lives</i> </b><br/>  <br/> Meet Oldguy: your regular aging superhero whose powers have dwindled over the years, and whose very mechanics are seriously fizzling. In seriocomic misadventures, Oldguy valiantly attempts to continue his former heroism in a somewhat wry version of Faulknerian endurance, defeating his enemies time and again—if not through superhuman abilities, then at least by “outliving the sons-a-bitches.” With its comic book-style illustrations, <i>Oldguy</i> inhabits a space all to itself—not strictly a poetry collection, not quite a graphic novel, but a hybrid sure to delight.<br/>  <br/> “An exhilarating read that I didn’t want to put down except to laugh and to shake my seventy-eight-year-old head in admiration.” —Ron Koertge, author of <i>Shakespeare Makes the Playoffs</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Trowbridge
      </h2>
      
      <p class="authorDescription body article"><P>A former Poet Laureate of Missouri, <B>William Trowbridge</B> is the author of six full poetry collections and three chapbooks. His new collection, <I>Tilt-A-Whirl</I>, is forthcoming from Red Hen Press in 2016. His awards include an Academy of American Poets Prize, a Pushcart Prize, a Bread Loaf Writers&rsquo; Conference scholarship, a Camber Press Poetry Chapbook Award, and fellowships from The MacDowell Colony, Ragdale, Yaddo, and The Anderson Center. He lives in the Kansas City area.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Red Hen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42e5f7da